import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Box } from '@mui/system'
import ModalContainer from '../../Modals/ModalContainer'
import { hideModal } from '../../../redux/actions'
import StyledLink from '../../StyledLink'
import { MUIFormTextInput } from '../../@Common/Form/TextInput/FormTextInput'
import { Button, Grid } from '@mui/material'
import DeleteIcon from '@mui/icons-material/DeleteForever'
import { getFeatureFlags } from '../../../setup/configuration'

function PartnerDetailsModal({
    affiliate,
    partnerListing,
    customer,
    deletePartnerCustomer,
    searchMarketplaceCustomer,
    saveMarketplaceCustomer,
    onClickUpdatePartner
}) {
    const dispatch = useDispatch()
    const defaultSecondaryAction = { label: 'Close', onClick: () => dispatch(hideModal()) }
    const [processing, setProcessing] = useState(false)
    const [modalTitle, setModalTitle] = useState('Partner Details')
    const [secondaryAction, setSecondaryAction] = useState(defaultSecondaryAction)
    const [showCustomerSearch, setShowCustomerSearch] = useState(false)
    const [showSearchResults, setShowSearchResults] = useState(false)
    const [showSearchCustomerExists, setShowSearchCustomerExists] = useState(false)
    const [showDeleteCustomer, setShowDeleteCustomer] = useState(false)
    const [marketplaceCustomer, setMarketplaceCustomer] = useState(customer)
    const [netSuiteCustomer, setNetSuiteCustomer] = useState({ name: '', customerId: '', partnerName: '', mappingExists: false })
    const [netsuiteCustomerId, setNetsuiteCustomerId] = useState(null);
    const [updatedPartnerName, setUpdatedPartnerName] = useState('')
    const [updatedPartnerSuccess, setUpdatedPartnerSuccess] = useState(false)

    const getCustomerSearchResults = () => {
        setProcessing(true)
        searchMarketplaceCustomer(netsuiteCustomerId).then((resp) => {
            setNetSuiteCustomer(resp.data)
            if (resp.data.mappingExists) {
                setShowSearchResults(false)
                setShowSearchCustomerExists(true)
            } else {
                setShowSearchCustomerExists(false)
                setShowSearchResults(true)
            }
            setProcessing(false)
        }).catch((error) => {
            console.error('Search failed:', error)
        })
            .finally(() => {
                setProcessing(false)
            })
    }

    const saveCustomer = () => {
        setProcessing(true)
        let updatedCustomer = {
            partnerId: partnerListing.partnerId,
            netSuiteCustomerId: netSuiteCustomer.customerId,
            name: netSuiteCustomer.name
        }
        setMarketplaceCustomer(updatedCustomer)
        saveMarketplaceCustomer(updatedCustomer).then(() => {
            setShowCustomerSearch(false)
            setProcessing(false)
        }).catch((error) => {
            console.error('Save failed:', error)
        })
            .finally(() => {
                setShowCustomerSearch(false)
                setProcessing(false)
            })
    }

    const deleteCustomer = () => {
        deletePartnerCustomer(partnerListing.partnerId).then(() => {
            setMarketplaceCustomer({
                affiliateId: affiliate?.id,
                partnerId: partnerListing.partnerId,
            })
            setShowDeleteCustomer(false)
        }).catch((error) => {
            console.error('Delete failed:', error)
        })
            .finally(() => {
                setShowDeleteCustomer(false)
            })
    }

    const hideModalFn = (event, reason) => {
        if (reason === 'backdropClick' && modal) {
            return
        }
        dispatch(hideModal())
    }

    useEffect(() => {
        if (showDeleteCustomer) {
            setModalTitle('Delete NetSuite Customer Link')
            setSecondaryAction(null)
        }
        else if (showCustomerSearch) {
            setModalTitle('Link NetSuite Customer')
            setSecondaryAction(null)
        }
        else {
            setModalTitle('Partner Details')
            setSecondaryAction(defaultSecondaryAction)
        }
    }, [showCustomerSearch, showDeleteCustomer])
    const { EnablePartnerDetailsModal: showNetSuiteDetails } = getFeatureFlags()

    return (
        <ModalContainer
            title={modalTitle}
            maxWidth="sm"
            fullWidth="true"
            modal
            onClose={hideModalFn}
            processing={processing}
            actions={{
                secondaryAction: secondaryAction,
            }}
        >
            {!showCustomerSearch && !showDeleteCustomer &&
                <>
                    {showNetSuiteDetails &&
                        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '1px' }}>
                            <Box sx={{ fontWeight: 'bold', marginRight: '10px' }}>NetSuite Customer ID:</Box>
                            {marketplaceCustomer?.netSuiteCustomerId ?
                                <>
                                    <Box>{marketplaceCustomer?.netSuiteCustomerId}</Box>
                                    <DeleteIcon
                                        onClick={() => setShowDeleteCustomer(true)}
                                        sx={{ color: '#0E5777', cursor: 'pointer' }}
                                    />
                                </>
                                :
                                <Box>(none)
                                    <StyledLink
                                        key="linkeCustomerRecord"
                                        contents="Link Customer Record"
                                        clickHandlerOnly
                                        onClick={() => { setShowCustomerSearch(true) }}
                                        styles={{ marginLeft: '5px' }}
                                    />
                                </Box>
                            }
                        </Box>
                    }
                </>
            }
            {marketplaceCustomer?.name && !showDeleteCustomer &&
                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '1px' }}>
                    <Box sx={{ fontWeight: 'bold', marginRight: '10px' }}>NetSuite Customer Name:</Box>
                    <Box>{marketplaceCustomer?.name}</Box>
                </Box>
            }
            {showDeleteCustomer &&
                <Box>
                    <Box>Are you sure you want to delete the link to this NetSuite customer? Deleting the link will impact reporting and invoice management.</Box>
                    <Grid container sx={{ marginTop: '10px' }} justifyContent="flex-end" spacing={2}>
                        <Grid item xs={2}>
                            <Button
                                variant="text"
                                onClick={() => { setShowDeleteCustomer(false) }}
                                label={'Cancel'}
                                style={{
                                    minHeight: '36px',
                                    minWidth: '64px',
                                }}
                            >
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item xs={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => deleteCustomer()}
                                label={'Search'}
                                style={{
                                    minHeight: '36px',
                                }}
                            >
                                Delete
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            }
            {showCustomerSearch &&
                <Box>
                    {!showSearchResults && !showSearchCustomerExists ?
                        <Box>
                            <Box>
                                <MUIFormTextInput
                                    name="netsuiteCustomerId"
                                    label="Customer ID"
                                    gxid="netsuiteCustomerId"
                                    value={netsuiteCustomerId}
                                    onChange={(e) => setNetsuiteCustomerId(e)}
                                />
                            </Box>
                            <Grid container sx={{ marginTop: '10px' }} justifyContent="flex-end" spacing={2}>
                                <Grid xs={2}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => getCustomerSearchResults()}
                                        label={'Search'}
                                        style={{
                                            minHeight: '36px',
                                            minWidth: '64px',
                                        }}
                                    >
                                        Search
                                    </Button>
                                </Grid>
                                <Grid xs={2}>
                                    <Button
                                        variant="text"
                                        onClick={() => { setShowCustomerSearch(false) }}
                                        label={'Cancel'}
                                        style={{
                                            minHeight: '36px',
                                            minWidth: '64px',
                                            marginLeft: '10px',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                        : showSearchCustomerExists ?
                            <>
                                {netSuiteCustomer.isError ?
                                    <Box>{netSuiteCustomer.error}</Box> :
                                    <Box>This customer record is already linked to {netSuiteCustomer.mappedName}</Box>
                                }
                                <Grid container sx={{ marginTop: '10px' }} justifyContent="flex-end">
                                    <Grid item xs={2}>
                                        <Button
                                            variant="text"
                                            onClick={() => { setShowSearchCustomerExists(false) }}
                                            label={'Cancel'}
                                            style={{
                                                minHeight: '36px',
                                                minWidth: '64px',
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </>
                            :
                            <>
                                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <Box sx={{ fontWeight: 'bold', marginRight: '10px' }}>NetSuite Customer ID:</Box>
                                    <Box>{netSuiteCustomer.customerId}</Box>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <Box sx={{ fontWeight: 'bold', marginRight: '10px' }}>Customer Name:</Box>
                                    <Box>{netSuiteCustomer.name}</Box>
                                </Box>
                                <Grid container sx={{ marginTop: '10px' }} justifyContent="flex-end" spacing={2}>
                                    <Grid item xs={2}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => saveCustomer()}
                                            label={'Search'}
                                            style={{
                                                minHeight: '36px',
                                            }}
                                        >
                                            Save
                                        </Button>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Button
                                            variant="text"
                                            onClick={() => { setShowSearchResults(false) }}
                                            label={'Cancel'}
                                            style={{
                                                minHeight: '36px',
                                                minWidth: '64px',
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </>
                    }
                </Box>
            }
        </ModalContainer>
    )
}

export default PartnerDetailsModal    